import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RouterService {
  constructor(private router: Router) {}

  back(route: ActivatedRoute) {
    this.router.navigate(['./'], { relativeTo: route.parent });
  }

  basket(route: ActivatedRoute) {
    this.router.navigate(['Basket'], { relativeTo: route.parent ?? route });
  }

  create(route: ActivatedRoute) {
    this.router.navigate(['Create'], { relativeTo: route.parent ?? route });
  }

  edit(id: string, route: ActivatedRoute) {
    this.router.navigate(['Edit', id], { relativeTo: route.parent ?? route });
  }

  path(path: string, route: ActivatedRoute) {
    this.router.navigate([path], { relativeTo: route.parent });
  }

  report(route: ActivatedRoute) {
    this.router.navigate(['Report'], { relativeTo: route.parent ?? route });
  }

  report2(route: ActivatedRoute) {
    this.router.navigate(['Report2'], { relativeTo: route.parent ?? route });
  }

  top() {
    this.router.navigate(['/']);
  }
}
